import { render, staticRenderFns } from "./IconPowerButton.vue?vue&type=template&id=5d83891c"
import script from "./IconPowerButton.vue?vue&type=script&lang=js"
export * from "./IconPowerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports